import { render } from "./PearsonVue.vue?vue&type=template&id=c28d47fe&scoped=true"
import script from "./PearsonVue.vue?vue&type=script&lang=js"
export * from "./PearsonVue.vue?vue&type=script&lang=js"

import "./PearsonVue.vue?vue&type=style&index=0&id=c28d47fe&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c28d47fe"

export default script